import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="cart-page"
export default class extends Controller {
  static targets = ["totalPrice"]

  async update(event) {
    const button = event.target.closest("[data-sku-id]")
    if (!button) return

    const id = button.dataset.skuId
    const quantity = parseInt(button.dataset.quantity, 10)

    if (quantity >= 0) {
      await this._sendUpdate(id, quantity)
    }
  }

  async remove(event) {
    event.preventDefault()
    const button = event.target.closest("[data-sku-id]")
    if (!button) return

    const id = button.dataset.skuId
    await this._sendUpdate(id, 0)
  }

  async _sendUpdate(id, quantity) {
    try {
      const res = await fetch("/cart/change.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json"
        },
        body: JSON.stringify({ sku_id: id, quantity })
      })

      if (res.ok) {
        // Reload page to get updated cart HTML
        window.location.reload()
      } else {
        alert("Failed to update cart")
      }
    } catch (err) {
      alert("Network error")
    }
  }
}
